export const getNewsletterUnsubscriptionModel = (state) => {
  return {
    unsubscribeReasons: state.newsletterUnsubscription.unsubscribeReasons,
    loading: state.newsletterUnsubscription.loading,
    unsubscriptionSuccessed: state.newsletterUnsubscription.unsubscriptionSuccessed,
    showUnsubscriptionFeedbackForm: state.newsletterUnsubscription.showUnsubscriptionFeedbackForm,
    feedbackSavedSuccessfully: state.newsletterUnsubscription.feedbackSavedSuccessfully,
  };
};
